// extracted by mini-css-extract-plugin
export default {"CommentsButton":"ij_a bhc_wv bhc_iz bhc_xj bhc_i bhc_j bhc_q bhc_vr bhc_er bhc_sm bhc_sn bhc_eb","CommentsButton__icon":"ij_b bhc_rx"};